import React from 'react'
import { SignupSecretLinkQuery } from '../signup-with-secret-link/SelfSignupWithSecretLink.codegen'
import { useLoginContext } from 'front-end/src/pages/auth/login/LoginContext'
import { observer } from 'mobx-react'

export type SelfSignupContextType = {
  organisation: NonNullable<SignupSecretLinkQuery>['organisation']
}

export const SelfSignupContext = React.createContext<SelfSignupContextType>(
  null as unknown as SelfSignupContextType
)
type WithSelfSignupContextProps = {
  data: SignupSecretLinkQuery
}

export const WithSelfSignupContext: React.FC<WithSelfSignupContextProps> =
  observer(({ data, children }) => {
    const { selfSignupToken } = useLoginContext()
    const context = React.useMemo(
      () => ({
        token: selfSignupToken,
        organisation: data?.organisation
      }),
      [data, selfSignupToken]
    )

    return (
      <SelfSignupContext.Provider value={context}>
        {children}
      </SelfSignupContext.Provider>
    )
  })
WithSelfSignupContext.displayName = 'WithSelfSignupContext'

export const useSelfSignupContext = () => React.useContext(SelfSignupContext)
